import { useAppSelector } from "@/store/hooks";
import {
  selectAppRoles,
  selectIsAdmin,
  selectIsReadOnlyUser,
  //   selectHasRole,
  //   selectHasAnyRole,
  //   selectHasAllRoles,
} from "@/store/selectors/authSelectors";
import { AppRole } from "@/service/AppRoleService";

export const useRoles = () => {
  const appRoles = useAppSelector(selectAppRoles);
  const isAdmin = useAppSelector(selectIsAdmin);
  const isReadOnlyUser = useAppSelector(selectIsReadOnlyUser);

  const hasRole = (role: AppRole) => appRoles.includes(role);
  const hasAnyRole = (roles: AppRole[]) =>
    roles.some((role) => appRoles.includes(role));
  const hasAllRoles = (roles: AppRole[]) =>
    roles.every((role) => appRoles.includes(role));

  return {
    appRoles,
    isAdmin,
    isReadOnlyUser,
    hasRole,
    hasAnyRole,
    hasAllRoles,
  };
};
